import { useMemo } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Returns a map of conditional links rules to determine their rendering.
 */
export const useConditionalLinksRules = (): Record<string, boolean> => {
  const isUsableNetEnabled = useFeatureFlag('cels-3985-usable-net-enabled');

  return useMemo(
    () => ({
      [ACCESSIBILITY_STATEMENT_ID]: isUsableNetEnabled,
    }),
    [isUsableNetEnabled],
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const ACCESSIBILITY_STATEMENT_ID = 'accessibility-statement';
